/**
 * Device-capability helpers.
 *
 * `isTouchPrimaryDevice()` returns true when the device's PRIMARY pointer is
 * coarse (a finger) — i.e. phones and tablets, but NOT a desktop/laptop that
 * merely has a touchscreen (those report a fine primary pointer).
 *
 * We use this to decide Enter-key behavior in chat composers: on touch-first
 * devices the on-screen return key should insert a newline (it's far too easy
 * to hit by accident mid-message), matching ChatGPT/Claude. Sending is then
 * done only via the send button. On desktop, Enter sends / Shift+Enter newlines.
 */
export function isTouchPrimaryDevice() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(pointer: coarse)').matches;
}

export default isTouchPrimaryDevice;
